export default "__VITE_ASSET__DldF797j__"